<template>
  <div class="text-center mb-12 mt-12">
    <h2 class="relative z-10">{{ title }}</h2>

    <p class="relative z-10">{{ info }}</p>

    <div
      v-if="items"
      class="flex justify-center flex-wrap"
    >
      <div
        v-for="employee in items"
        :key="employee.id"
        class="text-center block w-full sm:w-1/3 px-2 pb-4"
      >
        <div v-if="images" class="mb-3">
          <img
            v-if="employee.images" :src="employee.images.medium" :alt="employee.name"
            class="mx-auto w-52 h-52 object-cover rounded"
          />

          <div v-else class="mx-auto w-52 h-52 bg-action text-action rounded flex items-center justify-center">
            <p class="text-3xl font-bold">
              {{
                employee.displayName
                  .charAt(0)
                  .toUpperCase()
              }}
            </p>
          </div>
        </div>

        <div>
          <h5 class="font-semibold">{{ employee.displayName }}</h5>

          <p class="text-sm opacity-80 line-clamp-4 overflow-hidden">
            {{ employee.bio }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Employee } from '@@/types/api';

const { $api } = useNuxtApp()

interface Props {
  title?: string
  info?: string
  employees?: string | string[]
  images?: boolean | string
}

const props = withDefaults(defineProps<Props>(), {
  title: 'Title',
  info: 'Info',
  employees: () => [],
  images: true
})

const items = ref<Employee[]>([])

onMounted(async () => {
  await fetchEmployees()
})

const fetchEmployees = async () => {
  try {
    let employees = props.employees

    if (employees && employees !== 'undefined' && typeof employees === 'string') {
      employees = employees.split(',')
    }

    const response = await $api.location.employees(employees)

    const _items = response.employees

    if (_items.length && employees.length) {
      _items.sort((a, b) => {
        return employees.indexOf(a.id) - employees.indexOf(b.id)
      })
    }

    items.value = _items
  } catch (e) {
    // console.log(e)
  }
}
</script>
